import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const shipStationSettings = defineIntegrationSettings({
  fields: {},
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {
    authError: z.boolean(),
    packagesSyncedAt: z.date().nullable(),
    tagsSyncedAt: z.date().nullable(),
    learningSyncedAt: z.date().nullable(),
    usersSyncedAt: z.date().nullable(),
    locationsSyncedAt: z.date().nullable(),
    carriersSyncedAt: z.date().nullable(),
  },
});
